import "./Hero.scss";

interface HeroProps {
  title: string;
  body: JSX.Element;
  imageSrc: string;
  imageAlt: string;
}

const Hero = ({ title, body, imageSrc, imageAlt }: HeroProps): JSX.Element => {
  return (
    <div className="hero">
      <div className="hero__image">
        <img src={imageSrc} alt={imageAlt} />
      </div>
      <div className="hero__content">
        <h1>{title}</h1>
        {body}
      </div>
    </div>
  );
};

export default Hero;
